import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {VitHeadLinks} from '../../components/modules/pannelli/HeadLink';

import '../../components/modules/pannelli/themesScreen.scss';

function InovazioneViti() {
    const {theme} = useSingleTheme('vitigno');
    const vitigno_Theme = theme;
    const {articles} = useArticles('vitigno');
    let article = articles.slice(3, 4) || [];
    const articles_Inova = article[0] 

    const {paragraphs} = useParagraphs('vitigno_4');

    return (
        <section>
            {theme && <VitHeadLinks title={vitigno_Theme.tema_titolo} /> }
            <ThemesScreen theme={vitigno_Theme} article={articles_Inova} paragraphs={paragraphs}/> 
        </section>
    )
}
export default InovazioneViti;
